import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function channelCell(visibleColumns: any) {
  if (!visibleColumns.includes('channel')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Channel', { ns: 'sales' })} />,
    dataIndex: ['channel'],
    key: 'channel',
    render: (channel: any) => {
      // Display "SOB_JOURNEY" instead of "SOB_DROPPED_JOURNEY" in the table
      const displayValue = channel === 'SOB_DROPPED_JOURNEY' ? 'SOB_JOURNEY' : channel;
      return <CellText>{displayValue}</CellText>;
    },
    width: 120,
  };
}

export default channelCell;
